import Swiper from 'swiper';

export default function gallerySlider(selector, navigationButtons, mainScroll) {
	let slider = new Swiper(selector, {
		slidesPerView: 1,
		spaceBetween: 20,
		breakpoints: {
			// when window width is >= 480px
			640: {
				slidesPerView: 2,
				spaceBetween: 24,
			},
		},
		grabCursor: true,
		// virtualTranslate: true,
		// watchSlidesProgress: true,
		// watchSlidesVisibility: true,
		freeMode: true,
		centeredSlides: true,
		loop: true,
		pagination: {
			el: '.swiper-pagination',
			clickable: true,
		},
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
		on: {
			touchStart: function() {
				navigationButtons.forEach(button => {
					button.classList.add('touch');
				});

				let slides = this.el.getElementsByTagName('img');

				for (let index = 0; index < slides.length; index++) {
					const slide = slides[index];
					slide.classList.add('touch');
				}
			},
			touchEnd: function() {
				navigationButtons.forEach(button => {
					button.classList.remove('touch');
				});

				let slides = this.el.getElementsByTagName('img');

				for (let index = 0; index < slides.length; index++) {
					const slide = slides[index];
					slide.classList.remove('touch');
				}
			},
		},
	});

	mainScroll.on('scroll', instance => {
		slider.setTranslate(-instance.scroll.y / 3);
	});
}



// WEBPACK FOOTER //
// ./scripts/components/gallery-slider.js